import React from 'react';
export const SocialPage = React.lazy(() => import('./SocialPage'));